import React, { useState, useContext, useMemo, useRef, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { Box, InputBase } from '@mui/material';

import ScansContext from "../contexts/ScansContext"
import searchIcon from "../images/searchIcon.svg"

// S8 : recherche globale de la maquette. Cherche à la fois dans les scans
// (par nom) et dans les candidats (nom + email), sur les données déjà
// chargées par ScansContext — aucun appel serveur supplémentaire.

/* PD-10 (25/09/2026) : estRecruteur vaut false par défaut. Un appel qui
   oublierait de le passer montre donc la vue du candidat (ni candidats, ni
   nombre de candidats) : un oubli ne doit rien révéler. DashboardNavbar le
   passe explicitement (type "theScanRecruiter"). */
const GlobalSearch = ({ estRecruteur = false }) => {
  const navigate = useNavigate();
  const ctx = useContext(ScansContext)
  const scans = ctx?.scans
  const [q, setQ] = useState("")
  const [ouvert, setOuvert] = useState(false)
  const zone = useRef(null)

  useEffect(() => {
    const dehors = (e) => { if (zone.current && !zone.current.contains(e.target)) setOuvert(false) }
    document.addEventListener("mousedown", dehors)
    return () => document.removeEventListener("mousedown", dehors)
  }, [])

  const resultats = useMemo(() => {
    const t = q.trim().toLowerCase()
    if (t.length < 2) return { scans : [], candidats : [] }
    const s = (scans || []).filter((sc) => (sc?.name || "").toLowerCase().includes(t)).slice(0, 5)
    const c = []
    ;(estRecruteur ? (scans || []) : []).forEach((sc) => {
      ;(sc?.userIDs || []).forEach((u) => {
        if ((u?.userName || "").toLowerCase().includes(t) || (u?.userEmail || "").toLowerCase().includes(t)) {
          c.push({ nom : u?.userName, email : u?.userEmail, scanID : sc?.id, scanNom : sc?.name })
        }
      })
    })
    return { scans : s, candidats : c.slice(0, 6) }
  }, [q, scans, estRecruteur])

  const total = resultats.scans.length + resultats.candidats.length

  const aller = (id) => {
    setOuvert(false); setQ("")
    navigate(estRecruteur ? ('/app/scan/' + id) : '/app/scans')
  }

  const ligneSx = {
    padding:"10px 16px",
    cursor:"pointer",
    display:"flex",
    flexDirection:"column",
    gap:"2px",
    "&:hover" : { backgroundColor:"#F7F7F7" },
  }

  return (
    <Box ref={zone} sx={{position:"relative", flex:1, height:"100%", display:"flex", alignItems:"center"}}>
      <Box sx={{display:"flex", alignItems:"center", gap:"12px", width:"100%", paddingLeft:"24px"}}>
        <img src={searchIcon} style={{width:"20px", height:"20px", opacity:0.75, flexShrink:0}} alt=""/>
        <InputBase
          value={q}
          onChange={(e) => { setQ(e.target.value); setOuvert(true) }}
          onFocus={() => setOuvert(true)}
          placeholder={estRecruteur ? "Rechercher un scan, un candidat…" : "Rechercher un scan…"}
          sx={{fontSize:"15px", color:"text.black", width:"100%", "& input::placeholder" : { color:"#565656", opacity:1 }}}
        />
      </Box>

      {(ouvert && q.trim().length >= 2) &&
        <Box sx={{
          position:"absolute",
          top:"64px",
          left:"12px",
          width:"420px",
          maxWidth:"calc(100vw - 40px)",
          background:"white",
          border:"1px solid black",
          boxShadow:"0px 1px 20px rgba(0,0,0,0.1)",
          zIndex:1300,
          maxHeight:"420px",
          overflowY:"auto",
        }}>
          {total === 0 &&
            <Box sx={{padding:"16px", fontSize:"14px", color:"#565656"}}>Aucun résultat</Box>
          }

          {resultats.scans.length > 0 &&
            <>
              <Box sx={{padding:"10px 16px 6px", fontSize:"11px", letterSpacing:"0.1em", textTransform:"uppercase", color:"#565656"}}>
                Scans
              </Box>
              {resultats.scans.map((sc, i) => (
                <Box key={"s"+i} onClick={() => aller(sc?.id)} sx={ligneSx}>
                  <Box sx={{fontSize:"15px", color:"text.black"}}>{sc?.name}</Box>
                  {/* PD-10 (25/09/2026) : decision d'Hicham, un candidat ne voit
                      AUCUNE statistique. Le nombre de candidats invites sur le
                      scan en est une (et il renseigne sur la concurrence) : on
                      ne le montre qu'au recruteur. */}
                  {estRecruteur &&
                    <Box sx={{fontSize:"13px", color:"#6B6B6B"}}>
                      {sc?.userIDs?.length || 0} candidat{(sc?.userIDs?.length || 0) > 1 ? "s" : ""}
                    </Box>
                  }
                </Box>
              ))}
            </>
          }

          {resultats.candidats.length > 0 &&
            <>
              <Box sx={{padding:"10px 16px 6px", fontSize:"11px", letterSpacing:"0.1em", textTransform:"uppercase", color:"#565656", borderTop: resultats.scans.length ? "1px solid #EFEFEF" : "none"}}>
                Candidats
              </Box>
              {resultats.candidats.map((c, i) => (
                <Box key={"c"+i} onClick={() => aller(c.scanID)} sx={ligneSx}>
                  <Box sx={{fontSize:"15px", color:"text.black"}}>{c.nom || c.email}</Box>
                  <Box sx={{fontSize:"13px", color:"#6B6B6B"}}>{c.email} · {c.scanNom}</Box>
                </Box>
              ))}
            </>
          }
        </Box>
      }
    </Box>
  )
}

export default GlobalSearch
